// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.arcade-room-header {
  padding: 10px 40px;
}
.arcade-room-header-item.first {
  margin-left: 26px;
  display: inline-block;
}
.room-cabinet-wrapper {
  width: 16px;
  float: left;
}
.icon-drag-handle-vertical {
  cursor: grab;
}
.cabinet-name {
  display: inline-block;
  padding-left: 10px;
  font-weight: 600;
  max-width: 90%;
}
.arcade-room-add-cabinet-wrapper {
  margin: 20px 0;
}
.sort-order-wrapper {
  display: inline-block;
  margin: 0 15px;
}
.arcade-room-item {
  margin-top: 15px;
}
.toggle-wrapper {
  padding-left: 26px;
  border-top: 1px solid #10161a1a;
  margin-top: 15px;
}
.toggle-header {
  padding: 15px 0;
}
.toggle-padder {
  padding: 0 0 15px 0;
}
.nkl-menu {
  padding: 0px;
  text-align: left;
}
.selectable-cabinet-list-item {
  padding-left: 6%;
}
.nkl-menu-item {
  padding-bottom: 10px;
}
.room-configuration-title {
  padding-left: 10px;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
